import { lazy } from 'react'
import type { Area } from '@briary/shared'
import type { NavItem, RouteDef } from '../types'

const SiteMetrics = lazy(() => import('./SiteMetrics'))
const PortalModels = lazy(() => import('../models/PortalModels'))

export const PORTAL_EXTRA_ROUTES: RouteDef[] = [
  { path: '/portal/site-metrics', component: SiteMetrics },
  { path: '/portal/models', component: PortalModels },
  { path: '/portal/models/:id', component: PortalModels },
]

export function withPortalModuleLinks(groups: { label: string; items: NavItem[] }[], area: Area): { label: string; items: NavItem[] }[] {
  if (area !== 'portal') return groups
  const links: NavItem[] = [
    { label: 'Site metrics', path: '/portal/site-metrics', icon: 'grid' },
    { label: 'SketchUp models', path: '/portal/models', icon: 'building' },
  ]
  return groups.some(group => group.label === 'My sites')
    ? groups.map(group => group.label === 'My sites' ? { ...group, items: [...group.items, ...links] } : group)
    : [...groups, { label: 'My sites', items: links }]
}
